import styled from "styled-components";
import photo1 from "assets/images/hermes-01.jpg";
import photo2 from "assets/images/hermes-02.jpg";
import photo3 from "assets/images/fios-01.jpg";

export const Container = styled.section`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;
  background-color: white;

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    flex-shrink: unset;
    flex-grow: unset;
    height: 100%;
  }
`;

export const Content = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 72px 88px 72px 197px;

  @media screen and (max-width: 1010px) {
    padding: 48px 40px;
    height: auto;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 424px 392px;
  grid-column-gap: 80px;

  @media screen and (max-width: 1010px) {
    grid-template-columns: unset;
    grid-column-gap: unset;
    grid-row-gap: 48px;
  }
`;

export const Text = styled.article`
  width: 100%;
  font-size: 15px;
  line-height: 22px;
  color: black;

  p {
    margin-bottom: 24px;

    a {
      text-decoration: underline;
      color: black;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  width: 100%;
  object-fit: contain;
`;

export const Photo1Wrapper = styled.div`
  position: relative;
`;

export const CreditPhoto1 = styled.span`
  font-size: 15px;
  line-height: 22px;
  color: black;
  display: block;
  position: absolute;
  bottom: 5px;
  left: -32px;
  writing-mode: vertical-rl;
  transform: rotate(180deg);

  @media screen and (max-width: 1010px) {
    bottom: -24px;
    left: 0px;
    writing-mode: unset;
    transform: rotate(0deg);
    font-size: 12px;
  }
`;

export const CreditPhoto2 = styled.span`
  font-size: 15px;
  line-height: 22px;
  color: black;
  display: block;
  position: absolute;
  top: 32px;
  left: 32px;

  @media screen and (max-width: 1010px) {
    top: 16px;
    left: 24px;
    font-size: 12px;
  }
`;

export const CreditPhoto3 = styled.span`
  font-size: 15px;
  line-height: 22px;
  color: black;
  display: block;
  position: absolute;
  top: 32px;
  left: 32px;

  @media screen and (max-width: 1010px) {
    top: 16px;
    left: 24px;
    font-size: 12px;
  }
`;

export const Photo2Wrapper = styled.div`
  position: relative;
  align-self: center;
`;

export const Photo2 = styled.img.attrs({ src: photo2 })`
  object-fit: contain;
  margin-right: 29px;

  @media screen and (max-width: 1010px) {
    width: 100%;
  }
`;

export const Photo3Wrapper = styled.div`
  position: relative;
  align-self: center;
`;

export const Photo3 = styled.img.attrs({ src: photo3 })`
  object-fit: contain;
  margin-right: 712px;

  @media screen and (max-width: 1010px) {
    margin-right: 0;
    width: 100%;
  }
`;
